import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-main-container',
  templateUrl: './main-container.component.html',
  styleUrls: ['./main-container.component.scss']
})
export class MainContainerComponent {
  @Input() header?: string;
  @Input() subheader?: string;
  @Input() backButton?: boolean = false;

  // Evento de clic
  @Output() clicked = new EventEmitter<void>();

  onClick() {
    this.clicked.emit(); // Emitir evento si no está deshabilitado
  }
}
